import template from './ApiProgessBar.component.html';
import './ApiProgessBar.component.css';
import {lazyRegister} from '@/Core/lazyRegister';

lazyRegister.component('apiProgressBar', {
    template: template,
    controller: [
        '$element',
        function ($element) {
            this.$onInit = function () {
                $element.addClass('api-progress-bar');
                console.log('progress-bar init')
            };
        }
    ]

});